import React, { memo, useState } from "react";
import { LoadingButton, Icon } from "investira.react.components";
import services from "../../../services";
import withResponseHandling from "../../../hoc/withResponseHandling";

const AddEnquadramentoPadrao = memo((props) => {
  const { callback } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit() {
    setIsSubmitting(true);
    services.enquadramentos.padrao(
      {},
      (rRes) => {
        console.log(rRes.data);
        callback && callback();
      },
      (rErr) => {
        props.responseErrorHandling(rErr);
      },
      () => {
        setIsSubmitting(false);
      }
    );
  }

  return (
    <LoadingButton
      variant="outlined"
      color="primary"
      startIcon={<Icon iconName="insert" size={16} />}
      size="small"
      sx={{ px: 2 }}
      onClick={() => handleSubmit()}
      disabled={isSubmitting}
      loading={isSubmitting}
    >
      Enquadramento Padrão
    </LoadingButton>
  );
});

export default withResponseHandling(AddEnquadramentoPadrao);
